import { render, staticRenderFns } from "./passwordRestConfirmation.vue?vue&type=template&id=d7992d4c&"
import script from "./passwordRestConfirmation.vue?vue&type=script&lang=js&"
export * from "./passwordRestConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports